import { storyblokEditable, StoryblokServerComponent } from '@storyblok/react/rsc';
import TabsClient from '@/components/TabsClient';

const ACTIVE_STYLES = {
  'black':        { active: 'bg-black text-white border-black',               hover: 'hover:bg-black hover:text-white hover:border-black' },
  'white':        { active: 'bg-white text-black border-white',               hover: 'hover:bg-white hover:text-black hover:border-white' },
  'blue':         { active: 'bg-blue text-white border-blue',                 hover: 'hover:bg-blue hover:text-white hover:border-blue' },
  'dark-blue':    { active: 'bg-dark-blue text-white border-dark-blue',       hover: 'hover:bg-dark-blue hover:text-white hover:border-dark-blue' },
  'lavender':     { active: 'bg-lavender text-black border-lavender',         hover: 'hover:bg-lavender hover:text-black hover:border-lavender' },
  'lime-green':   { active: 'bg-lime-green text-black border-lime-green',     hover: 'hover:bg-lime-green hover:text-black hover:border-lime-green' },
  'forest-green': { active: 'bg-forest-green text-white border-forest-green', hover: 'hover:bg-forest-green hover:text-white hover:border-forest-green' },
  'dark-green':   { active: 'bg-dark-green text-white border-dark-green',     hover: 'hover:bg-dark-green hover:text-white hover:border-dark-green' },
  'orange':       { active: 'bg-orange text-white border-orange',             hover: 'hover:bg-orange hover:text-white hover:border-orange' },
  'magenta':      { active: 'bg-magenta text-white border-magenta',           hover: 'hover:bg-magenta hover:text-white hover:border-magenta' },
  'pink':         { active: 'bg-pink text-black border-pink',                 hover: 'hover:bg-pink hover:text-black hover:border-pink' },
  'ocean':        { active: 'bg-ocean text-white border-ocean',               hover: 'hover:bg-ocean hover:text-white hover:border-ocean' },
  'yellow':       { active: 'bg-yellow text-black border-yellow',             hover: 'hover:bg-yellow hover:text-black hover:border-yellow' },
  'red':          { active: 'bg-red text-white border-red',                   hover: 'hover:bg-red hover:text-white hover:border-red' },
  'gray-light':   { active: 'bg-gray-light text-black border-gray-light',     hover: 'hover:bg-gray-light hover:text-black hover:border-gray-light' },
};

const Tabs = ({ blok }) => {
  const items = blok.items || [];
  const tabStyle = ACTIVE_STYLES[blok.active_tab_background || 'black'] || ACTIVE_STYLES.black;

  // Panels are rendered here (server) so they can hold any block; TabsClient
  // just shows the active one. A tab's content lives entirely in its body blocks.
  const panels = items.map((item) => (
    <div key={item._uid} {...storyblokEditable(item)}>
      {item.body?.map((b) => <StoryblokServerComponent blok={b} key={b._uid} />)}
    </div>
  ));

  return (
    <div {...storyblokEditable(blok)}>
      <TabsClient
        labels={items.map((i) => i.label)}
        activeClass={tabStyle.active}
        hoverClass={tabStyle.hover}
        contentBackground={blok.content_background || ''}
      >
        {panels}
      </TabsClient>
    </div>
  );
};

export default Tabs;
